import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cards from "../../components/Cards/Cards";
import PageHeader from "../../components/common/PageHeader";
import StatusToggle from "../../components/StatusToggle";
import api from "../../utils/api";
import { useRestaurantDetails } from "../../context/RestaurantDetailsContext";

const QUICK_ACTIONS = [
  {
    label: "Online Orders",
    emoji: "🛒",
    link: "/orderdetails",
    featureKey: "onlineOrders",
    bg: "bg-blue-50   border-blue-100   text-blue-700",
  },
  {
    label: "Table Bookings",
    emoji: "🍽️",
    link: "/table-booking",
    featureKey: "tableBooking",
    bg: "bg-green-50  border-green-100  text-green-700",
  },
  {
    label: "Takeaway",
    emoji: "🛍️",
    link: "/takeaway",
    featureKey: "takeaway",
    bg: "bg-amber-50  border-amber-100  text-amber-700",
  },
  {
    label: "Product Availability/Price Update",
    emoji: "📦",
    link: "/price-update",
    bg: "bg-violet-50 border-violet-100 text-violet-700",
  },
  {
    label: "Reports",
    emoji: "📊",
    link: "/orders-history",
    bg: "bg-cyan-50   border-cyan-100   text-cyan-700",
  },
  {
    label: "Settings",
    emoji: "⚙️",
    link: "/settings",
    bg: "bg-rose-50   border-rose-100   text-rose-700",
  },
];

const MainDash = () => {
  const navigate = useNavigate();
  const [restaurantStatus, setRestaurantStatus] = useState("online");
  const { restaurantDetails } = useRestaurantDetails() || {};

  const features = restaurantDetails?.restaurant?.features || {};
  const isFeatureEnabled = (key) => features?.[key] !== false;

  useEffect(() => {
    api.get("/settings/restaurantstatus")
      .then((res) => setRestaurantStatus(res.data?.status || "online"))
      .catch(() => {});
  }, []);

  const filteredQuickActions = QUICK_ACTIONS.filter((action) => {
    if (!action.featureKey) return true;
    return isFeatureEnabled(action.featureKey);
  });

  return (
    <div className="space-y-6 pb-8">
      {/* Header */}
      <PageHeader
        showBackButton={false}
        title="Dashboard"
        subtitle="Monitor your restaurant's performance and manage operations"
        action={
          <StatusToggle status={restaurantStatus} setStatus={setRestaurantStatus} />
        }
      />

      {/* Quick Actions */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4">
        <h2 className="text-base font-semibold text-gray-900 mb-1">Quick Actions</h2>
        <p className="text-sm text-gray-500 mb-3">Jump to frequently used sections</p>
        <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-2">
          {filteredQuickActions.map(({ label, emoji, link, bg }) => (
            <button
              key={link}
              onClick={() => navigate(link)}
              className={`flex flex-col items-center gap-1.5 p-3 rounded-xl border ${bg}
                          hover:scale-105 active:scale-95 transition-transform duration-150`}
            >
              <span className="text-xl">{emoji}</span>
              <span className="text-xs font-semibold text-center leading-tight">{label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <Cards />
      </div>
    </div>
  );
};

export default MainDash;
